var aclh_module_card_wall_masonry_grid = (function (aclh_module_card_wall_masonry_grid) {
    aclh_module_card_wall_masonry_grid.init = function(){
      
      if($('#aclh-wrapper .aclh-wall').length<=0) return false;


      $component = $('#aclh-wrapper .aclh-wall');



      $.each($component, function(index, component) {

        // inview 
        $('.aclh-wall-preloader', $(component)).on('inview', function(event, visible) {
            if (visible) {
                //in view]
                $('#aclh-wrapper .aclh-wall .aclh-wall-content').addClass('aclh-inview');
                // console.log('in view');
            } else {
                //out view
            }
        });

        var iso;

        // hide > 6 on load
        $.each($('.aclh-wall-content .aclh-wall-item',$(component)), function(index, val) {
           if(index>=6) {
            // $(this).css('display','none');
            $(this).addClass('unloaded');
           }
        });


        // show or hide load more button
        function showHideLoadMore(){
          if($('.aclh-wall-content .aclh-wall-item.unloaded',$(component)).length > 0) {
            $('.aclh-masonry-load-more',$(component)).show();
          } else {
            $('.aclh-masonry-load-more',$(component)).hide();
          }
        }



        // load more
        $(component).on('click', '.aclh-masonry-load-more', function(event) {
          event.preventDefault();
          $.each($('.aclh-wall-content .aclh-wall-item.unloaded',$(component)), function(index, val) {
             if(index>=6) return false;
             $(this).removeClass('unloaded');
          });
          $('.aclh-wall-content',$(component)).isotope('reloadItems').isotope();
          showHideLoadMore();
        });



        var masonryGrid = $('.aclh-wall-content',$(component));
        // masonryGrid.insertAdjacentHTML("afterend", "<div class='aclh-wall-preloader'>Loading...</div>");
        var masonryPreloader = $('.aclh-wall-preloader',$(component));


        ["load"].forEach(function(event) {
          // Adding little preloader information
          masonryGrid.hide();
          window.addEventListener(event, function() {
            imagesLoaded( masonryGrid, function() {
              masonryGrid.show();
              masonryPreloader.hide();
              // do masonry
              iso = $('.aclh-wall-content',$(component)).isotope({
                itemSelector: '.aclh-wall-item',
                percentPosition: true,
              });
              console.log('masonry on:',iso);
              masonryGrid.addClass('loaded');

              showHideLoadMore();
            });
          }, false);
        });



      });






    };
    return aclh_module_card_wall_masonry_grid;
}(aclh_module_card_wall_masonry_grid || {}));